import { Empty, Timeline as AntTimeline } from "antd";
import { useTranslation } from "react-i18next";
import type { LogDto } from "@audit-plan/shared";
import { fmtDT } from "../pills";
import { useIsMobile } from "../useIsMobile";

export function LogTimeline({ logs }: { logs: LogDto[] }) {
  const { t } = useTranslation();
  const mobile = useIsMobile();
  if (!logs.length) return <Empty description={t("none")} />;
  return (
    <AntTimeline
      items={logs.slice(0, 300).map((l) => ({
        label: mobile ? undefined : fmtDT(l.ts),
        children: (
          <div style={{ overflowWrap: "anywhere" }}>
            {mobile && <div style={{ fontSize: 12, opacity: 0.6 }}>{fmtDT(l.ts)}</div>}
            <b data-sensitive>{l.userName}</b> <span style={{ opacity: 0.6 }}>· {t(`role_${l.role || "viewer"}`, { defaultValue: l.role })}</span>
            <br />
            {l.action} <span style={{ opacity: 0.6 }}>{l.entity}</span> <span data-sensitive>{l.detail}</span>
          </div>
        ),
      }))}
      mode={mobile ? undefined : "left"}
    />
  );
}
